import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DetailsQueries } from '../../queries/details.queries';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AnalyticsService, fromMatchMedia } from 'smartauction-frontend-micro-library';
import { AuctionItem, ImageMetaData, DetailsState } from 'remarketing-angular-library';
import { Select, Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { BookValueTabsBlackBook, BookValueTabsNADA, VehicleOptionsMetaData, DetailCarouselComponent } from 'remarketing-ui-components-lib';
import { DetailsHeaderQuery } from '../../interfaces/detail-header.query';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { SellerLocationComponent } from '../seller-location/seller-location.component';
import { SellerUpdateComponent } from '../seller-update/seller-update.component';
import { ConditionDisclosuresComponent } from '../condition-disclosures/condition-disclosures.component';
import { VehicleDetailComponent } from '../vehicle-detail/vehicle-detail.component';
import { AuctionDetailComponent } from '../auction-detail/auction-detail.component';
import { NgTemplateOutlet, AsyncPipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-print-vdp-sell',
    templateUrl: './print-vdp-sell.component.html',
    styleUrls: ['./print-vdp-sell.component.scss'],
    imports: [TranslocoDirective, NgTemplateOutlet, AuctionDetailComponent, VehicleDetailComponent, DetailCarouselComponent, ConditionDisclosuresComponent, SellerUpdateComponent, SellerLocationComponent, AsyncPipe, DecimalPipe]
})
export class PrintVdpSellComponent implements OnInit, OnDestroy {
  @Select(DetailsQueries.images) images$: Observable<ImageMetaData[]>;
  @Select(DetailsQueries.equipmentAccessories) options$: Observable<VehicleOptionsMetaData>;

  isDesktop$ = fromMatchMedia('(min-width: 992px)');

  @Input() tabFocus = 0;
  @Input() blackBookValues: BookValueTabsBlackBook = {};
  @Input() nadaValues: BookValueTabsNADA = {};
  @Input() images: ImageMetaData[];
  @Input() auctionItem: AuctionItem;
  @Input() showHeading = true;
  @Input() vehicleInfo: DetailsHeaderQuery;
  maxEquipRows = 100;

  /**
   * Adobe Analytics overwrite jQuery and our plugins === borked slider.
   */
  slickAvailable = false;
  detailsState$ = new BehaviorSubject<'loading' | 'loaded' | 'error'>('loading');
  showImageGrid = false;

  destroyed$ = new Subject();
  detailCarouselData: any;

  constructor(private readonly route: ActivatedRoute,
    private readonly store: Store,
    private readonly analyticsService: AnalyticsService,
    private readonly translocoService: TranslocoService) {}


  ngOnInit(): void {
    this.translocoService.selectTranslateObject('UIComponents').subscribe(translatedObj => {
      this.detailCarouselData = translatedObj.detailCarousel;
    });
    this.store.select(DetailsState.detailsState).subscribe(state => {
      if (state.loading) {
        this.detailsState$.next('loading');
      } else {
        this.detailsState$.next('loaded');
      }
    });

    try {
      this.slickAvailable = typeof (window as any).jQuery.fn.slick !== 'undefined';
    } catch (e) {
      this.slickAvailable = false;
    }

    setTimeout(() => {
      this.analyticsService.trackPageLoad({
        page: {
          pageName: `${this.analyticsService.digitalData.page.category.site}:Sell:Manage:Details`,
          section: 'Sell',
          site: this.analyticsService.digitalData.page.category.site,
          subsection: 'Manage',
          title: 'Details',
          data: {
            vehicleList: this.route.snapshot ? this.route.snapshot.parent.paramMap.get('inventoryItemUuid') : ''
          }
        }
      });
    }, 200);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
